// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"Xpu5ncAi0iDxmQr6Q9K3","text":"YW17Y9dM6uUwV0CPt27i","size":"FAtlUaYflPqcnaEXSQ3V"};